import { BooleanAttribute } from '../../../team-apis/otterdam/taxonomy';
import { AttributeHelper } from './attribute-helper';

export class BooleanAttributeHelper extends AttributeHelper<BooleanAttribute> {
  getLabel(value: string, attribute: BooleanAttribute) {
    return value === attribute.options.true.value
      ? attribute.options.true.label
      : attribute.options.false.label;
  }

  getDefaultOptionValue(attribute: BooleanAttribute) {
    return attribute.options.true.isDefault
      ? attribute.options.true.value
      : attribute.options.false.value;
  }

  isInvalidValue(value: string, attribute: BooleanAttribute) {
    return (
      value !== attribute.options.true.value &&
      value !== attribute.options.false.value
    );
  }
}
